import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TeamService } from '../_services/team.service';
import { TeamMember } from '../_models/team-member';
import { environment } from 'src/environments/environment';
import { AppConstants } from '../_constants/constants';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-team',
    templateUrl: './team.component.html',
    styleUrls: ['./team.component.css'],
    standalone: false
})
export class TeamComponent implements OnInit {
    title = 'Meet our Team';
    loading = true;
    teamMembers: TeamMember[] = [];
    currentLanguage: string | null = null;

    constructor(
        private titleService: Title,
        private teamService: TeamService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.titleService.setTitle(this.title);
    }

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.currentLanguage = localStorage.getItem(AppConstants.CURRENT_LANG_STORE_KEY);
        }
        this.teamService
            .loadTeam()
            .subscribe(
                (teamMembers: TeamMember[]) => {
                    this.teamMembers = teamMembers;
                    this.loading = false;
                }
            );
    }

    getImageSrc(imagePath) {
        return imagePath !== '' && imagePath !== null && imagePath.includes('media') ?
            environment.image_cdn_url + '/' + imagePath : '/assets/images/blog-img1_2.jpg';
    }

}
